/*
  Coldture Halloween Sale 2026: free gifts with every cold plunge.
  Adds the matching gift set to the cart (one set per plunge), keeps gift
  quantities in step with plunge quantities, and removes gifts when the plunge
  leaves the cart. Gifts are priced at $0 by the "Halloween Sale | Free gift: ..."
  automatic Buy X Get Y discounts, which only apply when a plunge is in the cart.
  A plunge that gets the $2,000 "sauna + plunge bundle" discount gets no gifts.

  Active window: Oct 22 2026 12:00 AM to Oct 30 2026 11:59 PM Eastern
  (started early on Oct 22, when the sale discounts were switched on).
  Outside the window it adds nothing and clears any gift lines it added.
  To test outside the window, open any page with ?gift_test=1 (remembered for
  the browser session; ?gift_test=0 turns it off).
*/
(function () {
  'use strict';

  var START = Date.parse('2026-10-22T00:00:00-04:00');
  var END = Date.parse('2026-10-30T23:59:59-04:00');
  var FLAG_KEY = '_free_gift';
  var FLAG_VALUE = 'halloween26';

  // Gift variant IDs
  var KIT = 45431140450550;          // Premium Cold Plunge Chemical Starter Pack
  var FILTERS_3 = 44940762054902;    // Premium 20-Micron Filter, 3 filters
  var MAT_BARREL = 44940711887094;   // Dry Mat, Barrel + Barrel Lite / Find Your Courage
  var MAT_CLASSIC = 44940711854326;  // Dry Mat, Classic / Find Your Courage
  var SLEEVES = 44940786434294;      // Premium Dry Sleeves
  var LITE_FILTER = 48521891905782;  // Pro Plunge Lite filter
  var LARGE_2 = 47071375655158;      // Large 20-Micron Filter, 2 filters

  // Plunge product ID -> gift variant IDs (one of each per plunge)
  var RULES = {
    7667106644214: [KIT, FILTERS_3, MAT_BARREL, SLEEVES],  // barrel-cold-plunge-tub-bundle
    7550799184118: [KIT, FILTERS_3, MAT_CLASSIC, SLEEVES], // classic-cold-plunge-tub-bundle
    8471421157622: [KIT, FILTERS_3, MAT_BARREL, SLEEVES],  // ultra-barrel-light-cold-plunge
    8979589202166: [KIT, LITE_FILTER],                     // pro-plunge-lite
    8334499381494: [KIT, LARGE_2],                         // pro-cold-plunge
    9304102240502: [KIT, LARGE_2],                         // new-xtreme-plunge
    8979590643958: [KIT, LARGE_2],                         // xtreme-outdoor-cold-plunge
    9250744697078: [KIT, LARGE_2]                          // xtreme-outdoor-contrast-system
  };

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var OWN_HEADER = 'X-Coldture-Gift-Sync';

  function testMode() {
    try {
      var p = new URLSearchParams(window.location.search).get('gift_test');
      if (p === '1') sessionStorage.setItem('coldture_gift_test', '1');
      if (p === '0') sessionStorage.removeItem('coldture_gift_test');
      return sessionStorage.getItem('coldture_gift_test') === '1';
    } catch (e) {
      return false;
    }
  }

  // Master switch. false = never add gifts (and clear any gift lines this code added).
  var ENABLED = false;

  function isActive() {
    if (!ENABLED) return false;
    var now = Date.now();
    return testMode() || (now >= START && now <= END);
  }

  function isGiftLine(item) {
    return !!(item.properties && item.properties[FLAG_KEY] === FLAG_VALUE);
  }

  function request(path, body) {
    var opts = {
      method: body ? 'POST' : 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    };
    opts.headers[OWN_HEADER] = '1';
    if (body) {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return nativeFetch(root + path, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  // Plunges bought with the "$2,000 off sauna + plunge" bundle do not get gifts.
  // Counts how many units of a plunge line carry the bundle discount.
  var BUNDLE_TITLE = /sauna \+ plunge bundle/i;
  var BUNDLE_AMOUNT_CENTS = 200000;

  function bundledUnits(item) {
    var total = 0;
    var allocations = item.line_level_discount_allocations || [];
    allocations.forEach(function (a) {
      var title = (a.discount_application && a.discount_application.title) || '';
      if (BUNDLE_TITLE.test(title)) total += Number(a.amount) || 0;
    });
    if (!allocations.length && item.discounts) {
      item.discounts.forEach(function (d) {
        if (BUNDLE_TITLE.test(d.title || '')) total += Number(d.amount) || 0;
      });
    }
    if (total <= 0) return 0;
    return Math.min(item.quantity, Math.max(1, Math.round(total / BUNDLE_AMOUNT_CENTS)));
  }

  function desiredGifts(cart) {
    var want = {};
    if (!isActive()) return want;
    cart.items.forEach(function (item) {
      if (isGiftLine(item)) return;
      var gifts = RULES[item.product_id];
      if (!gifts) return;
      var qty = item.quantity - bundledUnits(item);
      if (qty <= 0) return;
      gifts.forEach(function (variantId) {
        want[variantId] = (want[variantId] || 0) + qty;
      });
    });
    return want;
  }

  function refreshUI(cart) {
    try {
      document.querySelectorAll('cart-count').forEach(function (el) {
        el.innerText = cart.item_count;
      });
    } catch (e) {}
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
  }

  var running = false;
  var pending = false;

  function sync() {
    if (running) {
      pending = true;
      return Promise.resolve();
    }
    running = true;
    var changed = false;

    return request('cart.js')
      .then(function (cart) {
        var want = desiredGifts(cart);
        var have = {};
        cart.items.forEach(function (item) {
          if (!isGiftLine(item)) return;
          (have[item.variant_id] = have[item.variant_id] || []).push(item);
        });

        var steps = [];
        var toAdd = [];
        var updates = {};
        var hasUpdates = false;

        Object.keys(have).forEach(function (variantId) {
          var lines = have[variantId];
          var target = want[variantId] || 0;
          lines.forEach(function (line, i) {
            var qty = i === 0 ? target : 0;
            if (line.quantity !== qty) {
              updates[line.key] = qty;
              hasUpdates = true;
            }
          });
        });

        if (hasUpdates) {
          // One request for every gift line that needs a new quantity
          steps.push(function () {
            return request('cart/update.js', { updates: updates });
          });
        }

        Object.keys(want).forEach(function (variantId) {
          if (!have[variantId] && want[variantId] > 0) {
            var props = {};
            props[FLAG_KEY] = FLAG_VALUE;
            toAdd.push({ id: Number(variantId), quantity: want[variantId], properties: props });
          }
        });

        if (toAdd.length) {
          steps.push(function () {
            return request('cart/add.js', { items: toAdd }).catch(function () {
              // One gift failing (e.g. out of stock) must not block the others
              return toAdd.reduce(function (p, item) {
                return p.then(function () {
                  return request('cart/add.js', { items: [item] }).catch(function (err) {
                    console.warn('[Coldture gifts] could not add variant ' + item.id, err);
                  });
                });
              }, Promise.resolve());
            });
          });
        }

        if (!steps.length) return null;
        changed = true;
        return steps.reduce(function (p, step) { return p.then(step); }, Promise.resolve())
          .then(function () { return request('cart.js'); });
      })
      .then(function (cart) {
        if (changed && cart) refreshUI(cart);
      })
      .catch(function (err) {
        console.warn('[Coldture gifts] sync failed', err);
      })
      .then(function () {
        running = false;
        if (pending) {
          pending = false;
          return sync();
        }
      });
  }

  var timer = null;
  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 250);
  }

  function isCartMutation(url) {
    try {
      var path = new URL(url, window.location.origin).pathname;
      return /\/cart\/(add|change|update|clear)(\.js)?$/.test(path);
    } catch (e) {
      return false;
    }
  }

  // Watch the theme's and apps' cart requests
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var own = false;
    try {
      var h = (init && init.headers) || (input && input.headers);
      if (h) own = h instanceof Headers ? h.has(OWN_HEADER) : !!h[OWN_HEADER];
    } catch (e) {}
    var result = nativeFetch(input, init);
    if (!own && isCartMutation(url)) {
      result.then(scheduleSync, scheduleSync);
    }
    return result;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) {
      this.addEventListener('loadend', scheduleSync);
    }
    return nativeOpen.apply(this, arguments);
  };

  window.addEventListener('pageshow', scheduleSync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
})();
